import { FilterDescriptor } from '@progress/kendo-data-query'
import { useGridState } from 'features/DataGrid'
import { useAppSelector } from 'store'

import { SelectFilter } from '../SelectFilter'

interface InstrumentFilterProps {
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
}

export const InstrumentFilter: React.FC<InstrumentFilterProps> = ({ filter, onFilterChange }) => {
  const { gridState } = useGridState()
  const instrumentType = gridState.filter.filters.find(
    (gridFilter) =>
      (gridFilter as FilterDescriptor).field === 'InstrumentTypeId' &&
      (gridFilter as FilterDescriptor).value
  )
  const instruments = useAppSelector((state) => state.tradingAccounts.instruments)

  const data = instrumentType
    ? instruments
        .filter((x) => x.typeId === (instrumentType as FilterDescriptor).value)
        .map((x) => ({ id: x.id, label: x.symbol, value: `${x.id}__${x.typeId}` }))
    : instruments.map((x) => ({ id: x.id, label: x.symbol, value: `${x.id}__${x.typeId}` }))

  return (
    <SelectFilter
      placeholder='Instrument Type'
      filter={filter}
      onFilterChange={onFilterChange}
      data={data}
      style={{ width: 240 }}
    />
  )
}
